import { PreferencesProvider } from './context/PreferencesContext';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { UploadProvider } from './context/UploadContext';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/common/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
      <PreferencesProvider>
        <AuthProvider>
          <ToastProvider>
            <UploadProvider>
              <a href="#main-content" className="sr-only">
                Skip to main content
              </a>
              <AppRoutes />
            </UploadProvider>
          </ToastProvider>
        </AuthProvider>
      </PreferencesProvider>
    </ErrorBoundary>
  );
}
